import { Box, HStack, Text, VStack } from 'native-base';
import React from 'react';

import { IconComponent } from 'app/hocs/withIconWrapper';

export type ReservationIconDetailProps = {
  icon: IconComponent;
  /** what the icon stands for, read out by screen readers in front of the value */
  label: string;
  note?: string;
  testID?: string;
  value: string | string[];
};

export default function ReservationIconDetail({
  icon: Icon,
  label,
  note,
  testID,
  value,
}: ReservationIconDetailProps) {
  const values = Array.isArray(value) ? value : [value];
  const valueText = values.join(', ');
  const hasNote = !!note?.trim();
  const accessibilityLabel = [label ? `${label}: ${valueText}` : valueText, hasNote ? note : '']
    .filter(Boolean)
    .join('. ');

  return (
    <VStack accessibilityLabel={accessibilityLabel} accessible space="1.5" testID={testID}>
      <HStack alignItems="flex-start" space="2">
        <Box
          accessibilityElementsHidden
          aria-hidden
          importantForAccessibility="no-hide-descendants"
        >
          <Icon color="black" size={16} style={{ marginTop: 2 }} />
        </Box>
        <VStack flex="1">
          {values.map((item) => (
            <Text key={item} fontSize="sm">
              {item}
            </Text>
          ))}
        </VStack>
      </HStack>
      {hasNote && (
        <Text color="#949494" fontSize="xs">
          {note}
        </Text>
      )}
    </VStack>
  );
}
